<template>
  <div>
    <input
      type="checkbox"
      name="answer"
      :id="answer.answerId"
      :value="answer.answerId"
      @click="$emit('answerSelected', $event.target.value)"
    />
    <label class="answer-label" :for="answer.answerId">
      <div
        class="answer-label-index"
        :style="{
            backgroundColor: getAnswerBackgroundColor(poll, index),
            color: getAnswerColor(poll, index),
            borderRight: `1px solid ${getAnswerBackgroundColor(poll, index)}`
          }"
        :class="{ 'correct-answer': (displayCorrectAnswer === true && answer.isGood) }"
        >{{ index + 1 }}</div>
      <div
        class="answer-label-content break-word"
        :style="{
            backgroundColor: isSelected ? getAnswerBackgroundColor(poll, index) : '#fff',
            color: isSelected ? getAnswerColor(poll, index) : '#3f536e'
          }"
        :class="{ 'correct-answer': (displayCorrectAnswer === true && answer.isGood) }"
        >{{ answer.texts[lang] }}</div>
    </label>
  </div>
</template>

<script>
import { getAnswerBackgroundColor, getAnswerColor } from '@/services/ColorService';
import { mapGetters } from 'vuex';

export default {
  name: 'answer-text-input',
  props: {
    poll: Object,
    answer: Object,
    index: Number,
    isSelected: Boolean,
    displayCorrectAnswer: Boolean
  },
  computed: {
    ...mapGetters({ lang: 'getInputLanguage' })
  },
  methods: {
    getAnswerBackgroundColor,
    getAnswerColor
  }
};
</script>

<style lang="scss" scoped>
input[type='checkbox'] {
  display: none;
}

.answer-label {
  font-weight: 700;
  display: flex;
  background-color: #fff;
  border-radius: 5px;
  cursor: pointer;
  box-shadow: var(--box-shadow);
}

.answer-label-index {
  display: flex;
  flex: 0 0 50px;
  width: 50px;
  justify-content: center;
  align-items: center;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
}

.answer-label-content {
  flex: 1;
  padding: 20px;
  transition: all 0.25s;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
}
</style>
